export default "__VITE_ASSET__BamrYFs___"